import React, { CSSProperties } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

const LOW_BATTERY: number = 20;
const LOW_BATTERY_COLOR: string = 'red';
const BATTERY_COLOR: string = 'black';

interface Props {
	batteryPercentage: number;
	className?: string;
	style?: CSSProperties;
	rotate90?: boolean;
}

const BatteryIcon: React.FunctionComponent<Props> = (props: Props) => {
	const getIcon = (): BringgFontIcons => {
		const { batteryPercentage } = props;

		if (batteryPercentage === 0) {
			return BringgFontIcons.BatteryVerEmpty;
		}
		if (batteryPercentage <= 25) {
			return BringgFontIcons.BatteryVerQuarter;
		}
		if (batteryPercentage <= 50) {
			return BringgFontIcons.BatteryVerHalf;
		}
		if (batteryPercentage <= 75) {
			return BringgFontIcons.BatteryVerThreeQuarters;
		}

		return BringgFontIcons.BatteryFull;
	};

	const getColor = (): string => {
		const { batteryPercentage } = props;
		return batteryPercentage < LOW_BATTERY ? LOW_BATTERY_COLOR : BATTERY_COLOR;
	};

	return (
		<BringgIcon
			iconName={getIcon()}
			color={getColor()}
			className={props.className}
			rotate90={props.rotate90}
			style={{ ...props.style }}
		/>
	);
};

export default BatteryIcon;
